import { Directive, HostBinding, HostListener, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';

@Directive({
  selector: '[backButton]',
  standalone: true,
})
export class BackButtonDirective implements OnChanges {
  private readonly navigation = inject(NavigationService);
  private readonly router = inject(Router);

  @HostBinding('class.hidden!') hidden = false;

  @Input() defaultBackUrl: string = null;
  @Input() forceDefault = false;

  @HostListener('click')
  onClick(): void {
    if (this.forceDefault) {
      this.router.navigate([this.defaultBackUrl], {
        queryParamsHandling: 'merge',
      });
      return;
    }

    this.navigation.back(this.defaultBackUrl);
  }

  ngOnChanges(): void {
    this.hidden = !this.navigation.hasPreviousPage() && !this.defaultBackUrl;
  }
}
